import { render, staticRenderFns } from "./KeywordsManage.vue?vue&type=template&id=67fc0776&"
import script from "./KeywordsManage.vue?vue&type=script&lang=js&"
export * from "./KeywordsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports